module.exports = __webpack_public_path__ + "img/waterMark.dab8e37c.png";